"use client";

import { useEffect, useState } from "react";

export default function DuMatchLeagues({
  league,
  matches = [],
  render = () => null,
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia("(min-width: 1024px)");
    const apply = () => setIsDesktop(!!mql.matches);
    apply();
    if (mql.addEventListener) mql.addEventListener("change", apply);
    else mql.addListener(apply);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", apply);
      else mql.removeListener(apply);
    };
  }, []);

  return (
    <>
      {/* MOBILE (matches demo-1/index.html MOBILE section) */}
      {!isDesktop ? (
      <section
        className="overflow-hidden rounded-2xl border border-white/10 bg-[var(--theme-foreground)]"
        style={{
          backgroundColor: "var(--theme-foreground)",
          border: "1px solid rgba(255,255,255,0.10)",
          borderRadius: "16px",
        }}
      >
        <div className="grid w-full grid-cols-[repeat(3,_auto)] gap-x-2 bg-[var(--theme-bg)] px-0 py-3">
          <div className="col-span-full">
            <button
              type="button"
              onClick={() => setIsExpanded((v) => !v)}
              className="grid cursor-pointer grid-cols-[repeat(3,_auto)] items-center gap-x-2 border-0 bg-white/10 text-left text-sm text-[var(--theme-text)] outline-none shadow-none ring-0 focus:outline-none focus-visible:outline-none rounded-none w-full"
              style={{
                border: 0,
                outline: "none",
                boxShadow: "none",
                borderRadius: 0,
              }}
            >
              <div className="grid  grid-cols-[1fr_auto] items-center gap-x-2 px-1 w-full">
                <div className="flex items-center gap-2">
                  <div className="grid h-6 w-6 place-items-center overflow-hidden rounded-full bg-white/10">
                    {league?.logo ? (
                      <img
                        className="h-4 w-4 object-contain opacity-90"
                        alt=""
                        src={league.logo}
                      />
                    ) : (
                      <span className="h-4 w-4" />
                    )}
                  </div>
                  <div className="line-clamp-1 text-left text-base font-semibold text-[var(--theme-text)]">
                    {league?.nameVN || league?.name || "Giải đấu"}
                  </div>
                </div>

                <svg
                  className={`ml-auto h-6 w-6 text-[var(--theme-text)] transition-transform ${
                    isExpanded ? "-rotate-90" : "rotate-90"
                  }`}
                  viewBox="0 0 22 22"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.203 5.993a.83.83 0 0 1 1.172 0l4.42 4.42a.83.83 0 0 1 0 1.173l-4.42 4.421a.829.829 0 0 1-1.172-1.172L12.037 11 8.203 7.165a.83.83 0 0 1 0-1.172"
                  />
                </svg>
              </div>
            </button>

            {isExpanded ? (
              <div className="px-4">
                {matches.map((match, idx) => (
                  <div
                    key={match?.id || idx}
                    className={idx ? "" : ""}
                  >
                    {render(match, idx)}
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </section>
      ) : null}

      {/* DESKTOP */}
      {isDesktop ? (
      <section className="overflow-hidden rounded-2xl bg-[var(--theme-foreground)]">
        <div className="overflow-x-auto pb-2">
          <div className="min-w-auto p-2">
            <div
              role="button"
              tabIndex={0}
              onClick={() => setIsExpanded((v) => !v)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setIsExpanded((v) => !v);
                }
              }}
              className="relative grid w-full grid-cols-[264px_1fr_1fr_1fr] items-center gap-x-5 rounded-t-[10px] bg-white/10 text-sm text-[var(--theme-text)] outline-none"
              style={{ border: 0, boxShadow: "none" }}
            >
              <div className="flex items-center gap-2 p-3 pl-4">
                <div className="grid h-7 w-7 place-items-center overflow-hidden rounded-full bg-white/10">
                  {league?.logo ? (
                    <img
                      className="h-5 w-5 rounded-full object-contain opacity-90"
                      alt=""
                      src={league.logo}
                    />
                  ) : (
                    <span className="h-5 w-5" />
                  )}
                </div>
                <div className="min-w-0 flex-1 truncate text-left text-sm font-normal text-[var(--theme-text)]">
                  {league?.nameVN || league?.name || "Giải đấu"}
                </div>
              </div>
              <div className="py-3 text-center text-[var(--theme-text-muted)]">Kèo chấp</div>
              <div className="py-3 text-center text-[var(--theme-text-muted)]">Tài xỉu</div>
              <div className="py-3 text-center text-[var(--theme-text-muted)]">1X2</div>
              <svg
                className={`pointer-events-none absolute right-4 top-1/2 h-[22px] w-[22px] -translate-y-1/2 text-[var(--theme-text)] transition-transform ${
                  isExpanded ? "-rotate-90" : "rotate-90"
                }`}
                viewBox="0 0 22 22"
                fill="none"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.203 5.993a.83.83 0 0 1 1.172 0l4.42 4.42a.83.83 0 0 1 0 1.173l-4.42 4.421a.829.829 0 0 1-1.172-1.172L12.037 11 8.203 7.165a.83.83 0 0 1 0-1.172"
                />
              </svg>
            </div>

            {isExpanded
              ? matches.map((match, idx) => (
                  <div key={match?.id || idx}>{render(match, idx)}</div>
                ))
              : null}
          </div>
        </div>
      </section>
      ) : null}
    </>
  );
}

